import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-professional-bodies-bp.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-professional-bodies-bp.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { CreateApplicationProfessionalBodiesBpConstants } from "./create-application-professional-bodies-bp.constants";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationProfessionalBodiesBpComponent = class CreateApplicationProfessionalBodiesBpComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    recipientSelectService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    professionalBodiesForm;
    markArchitectAsNotApplicableLabel = CreateApplicationProfessionalBodiesBpConstants.MARK_ARCHITECT_AS_NOT_APPLICABLE_LABEL;
    markArchitectAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesBpConstants.MARK_ARCHITECT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantToArchitectDetailsFormControlName = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ARCHITECT_FORM_CONTROL_NAME;
    copyApplicantDetailsToArchitectLabel = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ARCHITECT_LABEL;
    markEngineerAsNotApplicableLabel = CreateApplicationProfessionalBodiesBpConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL;
    markEngineerAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesBpConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerFormControlName = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerLabel = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL;
    markElectricalContractorAsNotApplicableLabel = CreateApplicationProfessionalBodiesBpConstants.MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_LABEL;
    markElectricalContractorAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesBpConstants.MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorFormControlName = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorLabel = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL;
    markFireConsultantAsNotApplicableLabel = CreateApplicationProfessionalBodiesBpConstants.MARK_FIRE_CONSULTANT_AS_NOT_APPLICABLE_LABEL;
    markFireConsultantAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesBpConstants.MARK_FIRE_CONSULTANT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToFireConsultantFormControlName = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_FIRE_CONSULTANT_FORM_CONTROL_NAME;
    copyApplicantDetailsToFireConsultantLabel = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_FIRE_CONSULTANT_LABEL;
    markOtherProfessionalAsNotApplicableLabel = CreateApplicationProfessionalBodiesBpConstants.MARK_OTHER_PROFESSIONAL_AS_NOT_APPLICABLE_LABEL;
    markOtherProfessionalAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesBpConstants.MARK_OTHER_PROFESSIONAL_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToOtherProfessionalFormControlName = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_OTHER_PROFESSIONAL_FORM_CONTROL_NAME;
    copyApplicantDetailsToOtherProfessionalLabel = CreateApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_OTHER_PROFESSIONAL_LABEL;
    architectFormControlName = CreateApplicationProfessionalBodiesBpConstants.ARCHITECT_FORM_CONTROL_NAME;
    engineerFormControlName = CreateApplicationProfessionalBodiesBpConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = CreateApplicationProfessionalBodiesBpConstants.ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    fireConsultantFormControlName = CreateApplicationProfessionalBodiesBpConstants.FIRE_CONSULTANT_FORM_CONTROL_NAME;
    otherProfessionalFormControlName = CreateApplicationProfessionalBodiesBpConstants.OTHER_PROFESSIONAL_FORM_CONTROL_NAME;
    showArchitectRequiredCheckbox = true;
    showArchitect = false;
    showEngineer = false;
    showElectricalContractor = false;
    showFireConsultant = false;
    showOtherProfessional = false;
    showSACAPOptions = false;
    architectDisableFilterBy = true;
    architectDisableAdd = true;
    architectDisableEditing = false;
    architectShowFields = true;
    architectIsInternal = false;
    architectGroups = [];
    architectLabel = CreateApplicationProfessionalBodiesBpConstants.ARCHITECT_LABEL;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = false;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = CreateApplicationProfessionalBodiesBpConstants.ENGINEER_LABEL;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = false;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = CreateApplicationProfessionalBodiesBpConstants.ELECTRICAL_CONTRACTOR_LABEL;
    fireConsultantDisableFilterBy = true;
    fireConsultantDisableAdd = true;
    fireConsultantDisableEditing = false;
    fireConsultantShowFields = true;
    fireConsultantIsInternal = false;
    fireConsultantGroups = [];
    fireConsultantLabel = CreateApplicationProfessionalBodiesBpConstants.FIRE_CONSULTANT_LABEL;
    otherProfessionalDisableFilterBy = true;
    otherProfessionalDisableAdd = true;
    otherProfessionalDisableEditing = false;
    otherProfessionalShowFields = true;
    otherProfessionalIsInternal = false;
    otherProfessionalGroups = [];
    otherProfessionalLabel = CreateApplicationProfessionalBodiesBpConstants.OTHER_PROFESSIONAL_LABEL;
    constructor(createApplicationService, recipientSelectService, aflaModuleStrategyService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.recipientSelectService = recipientSelectService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        try {
            if (this.appController.moduleSimulateMode) {
                this.architectGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
                this.engineerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
                this.contractorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
                this.fireConsultantGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
                this.otherProfessionalGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
            }
            else {
                this.architectGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.architectGroup);
                this.engineerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.engineerGroup);
                this.contractorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.electricalContractorGroup);
                this.fireConsultantGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.fireConsultantGroup);
                this.otherProfessionalGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.otherProfessionalGroup);
            }
            this.showSACAPOptions = stepMeta.enableSACAPLookup;
            if (this.showSACAPOptions) {
                this.configureProfBodiesForSACAP();
            }
            /*       var hasPreviousApplication = this.aflaModuleStrategyService.previousApplication;
                  if (hasPreviousApplication) {
                    this.getPreviousApplicantData();
                  } */
            this.changeDetectorRefs.detectChanges();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    onCopyApplicantDetailsToArchitectChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("architectRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("architectRecipient").enable();
        }
    }
    onCopyApplicantDetailsToEngineerChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("engineerRecipients").disable();
        }
        else {
            this.professionalBodiesForm.get("engineerRecipients").enable();
        }
    }
    onCopyApplicantDetailsToElectricalContractorChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("electricalContractorRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("electricalContractorRecipient").enable();
        }
    }
    onCopyApplicantDetailsToFireConsultantChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("fireConsultantRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("fireConsultantRecipient").enable();
        }
    }
    onCopyApplicantDetailsToOtherProfessionalChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("otherProfessionalRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("otherProfessionalRecipient").enable();
        }
    }
    onMarkArchitectAsNotApplicableChecked(event) {
        this.showArchitect = event.currentTarget.checked;
        if (this.showArchitect === false) {
            this.professionalBodiesForm.get("architectRecipient").disable();
            this.professionalBodiesForm.get("architectRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("architectRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect");
            copyControl.enable();
        }
    }
    onMarkEngineerAsNotApplicableChecked(event) {
        this.showEngineer = event.currentTarget.checked;
        if (this.showEngineer === false) {
            this.professionalBodiesForm.get("engineerRecipients").disable();
            this.professionalBodiesForm.get("engineerRecipients").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("engineerRecipients").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.enable();
        }
    }
    onMarkElectricalContractorAsNotApplicableChecked(event) {
        this.showElectricalContractor = event.currentTarget.checked;
        if (this.showElectricalContractor === false) {
            this.professionalBodiesForm.get("electricalContractorRecipient").disable();
            this.professionalBodiesForm.get("electricalContractorRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("electricalContractorRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
            copyControl.enable();
        }
    }
    onMarkFireConsultantAsNotApplicableChecked(event) {
        this.showFireConsultant = event.currentTarget.checked;
        if (this.showFireConsultant === false) {
            this.professionalBodiesForm.get("fireConsultantRecipient").disable();
            this.professionalBodiesForm.get("fireConsultantRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToFireConsultant");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("fireConsultantRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToFireConsultant");
            copyControl.enable();
        }
    }
    onMarkOtherProfessionalAsNotApplicableChecked(event) {
        this.showOtherProfessional = event.currentTarget.checked;
        if (this.showOtherProfessional === false) {
            this.professionalBodiesForm.get("otherProfessionalRecipient").disable();
            this.professionalBodiesForm.get("otherProfessionalRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToOtherProfessional");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("otherProfessionalRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToOtherProfessional");
            copyControl.enable();
        }
    }
    initForm() {
        this.professionalBodiesForm = this.aflaModuleStrategyService.form.get("professionalBodiesForm");
        if (this.professionalBodiesForm.get("markArchitectAsNotApplicable").value === true) {
            this.showArchitect = true;
            this.professionalBodiesForm.get("architectRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect");
            copyControl.enable();
        }
        else {
            this.showArchitect = false;
            this.professionalBodiesForm.get("architectRecipient").disable();
            this.professionalBodiesForm.get("architectRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect");
            copyControl.setValue(false);
            copyControl.disable();
        }
        if (this.professionalBodiesForm.get("markEngineerAsNotApplicable").value === true) {
            this.showEngineer = true;
            this.professionalBodiesForm.get("engineerRecipients").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.enable();
        }
        else {
            this.showEngineer = false;
            this.professionalBodiesForm.get("engineerRecipients").disable();
            this.professionalBodiesForm.get("engineerRecipients").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.setValue(false);
            copyControl.disable();
        }
        if (this.professionalBodiesForm.get("markElectricalContractorAsNotApplicable").value === true) {
            this.showElectricalContractor = true;
            this.professionalBodiesForm.get("electricalContractorRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
            copyControl.enable();
        }
        else {
            this.showElectricalContractor = false;
            this.professionalBodiesForm.get("electricalContractorRecipient").disable();
            this.professionalBodiesForm.get("electricalContractorRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
            copyControl.setValue(false);
            copyControl.disable();
        }
        if (this.professionalBodiesForm.get("markFireConsultantAsNotApplicable").value === true) {
            this.showFireConsultant = true;
            this.professionalBodiesForm.get("fireConsultantRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToFireConsultant");
            copyControl.enable();
        }
        else {
            this.showFireConsultant = false;
            this.professionalBodiesForm.get("fireConsultantRecipient").disable();
            this.professionalBodiesForm.get("fireConsultantRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToFireConsultant");
            copyControl.setValue(false);
            copyControl.disable();
        }
        if (this.professionalBodiesForm.get("markOtherProfessionalAsNotApplicable").value === true) {
            this.showOtherProfessional = true;
            this.professionalBodiesForm.get("otherProfessionalRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToOtherProfessional");
            copyControl.enable();
        }
        else {
            this.showOtherProfessional = false;
            this.professionalBodiesForm.get("otherProfessionalRecipient").disable();
            this.professionalBodiesForm.get("otherProfessionalRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToOtherProfessional");
            copyControl.setValue(false);
            copyControl.disable();
        }
        this.changeDetectorRefs.detectChanges();
    }
    configureProfBodiesForSACAP() {
        this.showArchitect = true;
        this.showArchitectRequiredCheckbox = false;
        this.professionalBodiesForm.get(this.markArchitectAsNotApplicableFormControlName).setValue(true);
        this.professionalBodiesForm.get("architectRecipient").enable();
        const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect");
        copyControl.enable();
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: RecipientSelectService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationProfessionalBodiesBpComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-professional-bodies-bp",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationProfessionalBodiesBpComponent);
export { CreateApplicationProfessionalBodiesBpComponent };
